import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { BUSINESS } from "../data";

export default function PaymentCancel() {
  return (
    <div className="min-h-[100svh] bg-[#030303] flex items-center justify-center px-5">
      <div className="max-w-lg w-full border border-zinc-800 bg-[#080808] p-10 text-center" data-testid="payment-cancel-page">
        <h1 className="font-display text-3xl font-bold uppercase tracking-tight">Booking not completed</h1>
        <p className="text-zinc-400 mt-4">No payment was taken. Your slot isn't held yet — you can try again anytime, or call us on <a className="text-[#FF3B30]" href={`tel:${BUSINESS.phoneRaw}`}>{BUSINESS.phone}</a>.</p>
        <Link to="/"><Button data-testid="cancel-home-btn" className="mt-8 rounded-none bg-[#FF3B30] hover:bg-[#D63026] text-white font-display uppercase tracking-widest">Back home</Button></Link>
      </div>
    </div>
  );
}
